
export default function ContactUs() {
    return (
        <div className="contact">
            <div className="contact-info">
                <h1>Our Contacts</h1>
                <p>
                    Earn while you connect others to what they need.
                    Our affiliate community is full of doers, creators, and hustlers, helping people access legit financial tools and getting paid for it.
                    <br />
                    Whether you’re a student, tech store, travel agent, or just someone with a solid network, there’s room for you here.
                    <br />
                    <strong>Join the movement. Share the value. Get paid.</strong>

                </p>
                <ul>
                    <li className="list">Address: 75 Mobolaji Bank Anthony Way, Ikeja, Lagos, Nigeria</li>
                    <li className="list">Phone Number: +234 9168344191</li>
                    <li className="list">Email: affiliate@pluscredit.systems</li>
                </ul>
            </div>

            <div className="contact-form">
                <h1>Ready to Get Started?</h1>

                <input
                    className="form-input"
                    placeholder="Your Name *"
                    type="text"
                    name="your-name"
                    required
                />
                <input
                    className="form-input"
                    placeholder="Phone No. *"
                    type="tel"
                    name="your-phone"
                    required
                />
                <input
                    className="form-input"
                    placeholder="Your Email *"
                    type="email"
                    name="your-email"
                    required
                />
                <textarea
                    className="form-textarea"
                    placeholder="Message..."
                    name="your-message"
                    rows="4"
                    required
                ></textarea>

                <button className="submit-btn">Send</button>
            </div>
        </div>
    );
}
